import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { addNCContent } from "../redux/actions/index";

const useNCReleases = (id, items) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (items && items.length > 0) {
      const match = id.match(/\{(.*?)\}/);
      items.forEach( (x,o) => {
        dispatch(addNCContent({ ref: `refC-${(x.audio && x.audio.ref) ? x.audio.ref : o}`, link: `link-refC-${(x.audio && x.audio.ref) ? x.audio.ref : o}`, action: `class`, scroll: true, order: (match && match[1]) ? match[1] : `A` }));
      } )
    }
  }, [id, items, dispatch])
  return null;
};

export default useNCReleases;
